import { mdiCheck, mdiInformationOutline, mdiMinus } from '@mdi/js'

export const PlansTableIcons = {
  checkmark: mdiCheck,
  info: mdiInformationOutline,
  minus: mdiMinus,
}

export type PlansTableElement = keyof typeof PlansTableIcons | string
